module.exports = __webpack_public_path__ + "img/Loading_40px_black.ce00fc7a.svg";